import { ActionType, CONNECTION_STATUS_TYPE } from "../ChatAction";

export default function setConnectionStatus(status: CONNECTION_STATUS_TYPE): ActionType {
    return {
        type: "connection_update",
        detail: {
            status,
            timestamp: +new Date()
        }
    };
}